// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  target: "https://taxgateway.oasisproducts.ng",
  apiBaseUrl: '/api',
  serverUrl: 'https://taxgateway.oasisproducts.ng/api',
  loginUrl: 'https://taxgateway.oasisproducts.ng/api',
  paymentUrl: 'https://taxgateway.oasisproducts.ng',
  recaptcha: {
    siteKey: '6LcgZL0lAAAAAGvUqVclaCQha9dH4lIlEvw9id0I'
  },
    remitaInLineKey:
        'RzAwMDA0OTIwMDh8OTU1OTc4MjM2N3wyMWQzZDgyZThjYzJmM2NmNzc2ZDk4OWM2MDE3NTU0NzA3NTNmYTgzNDEwNzA5ZDJiZDFlZWFkYjVhYTk1NTA0OTU5ZWVkZTNjM2VmNmU2Y2NjYTE2ZjE1NWYxZGQ3N2FlNDc5NzdmYjQyY2EzMDBhYzQxZWZjMDA5YzM1ZjRlMQ==',
    // merchantCode: 'MX64729',
    // payItemId: 'Default_Payable_MX64729',
    // interSwitchMode: 'LIVE',

    // merchantCode: 'MX91587',
    // payItemId: 'Default_Payable_MX91587',
    // interSwitchMode: 'TEST',
    // interSwitchOrderId: 'E4C4-F92E-E93D-407F3',
    // interSwitchCustId: '3449087551',
    merchantCode: 'VNA',
    payItemId: '103',
    interSwitchMode: 'TEST',
    interSwitchOrderId: 'E4C4-F92E-E93D-407F3',
    interSwitchCustId: '3449087551',
    url: "http://41.207.248.246:4090",
    vasApiEndpoint: '/assessments/vas-company-validation-rc'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
